import { z } from 'zod';

export const ResourceLinkSchema = z.object({
  name: z.string().min(1, 'Resource link name cannot be empty'),
  url: z.string().url('Invalid URL format for resource link').nullable(), // Nullable to allow removing a link
});

export type IResourceLinkDto = z.infer<typeof ResourceLinkSchema>;
